export enum PrintersSettingsType {
  AutoPrintReceipt = '_AUTO_PRINT_RECEIPT;',
  CashRegisterAutoOpen = '_CASH_REGISTER_AUTO_OPEN;',
  AutoPrintKitchenReceipt = '_AUTO_PRINT_KITCHEN_RECEIPT;',
  ShowUnprintedKitchenItems = '_SHOW_UNPRINTED_KITCHEN_ITEMS;',
}
